import $ from "jquery";
import SettingsWindow from "./settings-window";
import Status from "./status";
import CookieManager from "./cookie-manager";
import ConsentWindow from "./consent-window";
import Configuration from "./configuration";
import EventDispatcher from "./event-dispatcher";
import ElementAllower from "./element-allower";

(function () {
    // Quick and dirty way to prevent cookie notifications for Sitecore editors
    function isDisabled() {
        const isCsvGeneration = document.getElementsByClassName("csv-generation-container").length;
        // eslint-disable-next-line no-undef
        return isCsvGeneration || typeof Sitecore !== "undefined";
    }

    const openSettingsSelector = ".js-cookie-consent-open-settings";
    const acceptCookieSelector = ".js-cookie-consent-accept-category";

    const requiredCookiesName = "required";

    const startCookieConsent = function (config) {
        if (window.cookieSelectionDisabled) {
            return;
        }

        if (isDisabled()) {
            return;
        }

        const eventDispacher = new EventDispatcher();
        const configuration = new Configuration(config);
        const status = new Status(
            configuration.CookieName,
            configuration.Domain,
            eventDispacher,
            configuration.AcceptCallback,
            configuration.DeclineCallback,
        );

        if (!status.hasSelected()) {
            const consentWindow = new ConsentWindow(eventDispacher, configuration);
            consentWindow.createConsent(document.body);
        }

        const cookieManager = new CookieManager(configuration);
        cookieManager.init(eventDispacher);

        const elementAllower = new ElementAllower(configuration.HiddenClassName);
        elementAllower.init(eventDispacher, configuration.Categories);

        const openSettingsEventName = eventDispacher.openSettingsEventName();
        document.addEventListener(
            openSettingsEventName,
            () => {
                const settings = new SettingsWindow(status, configuration);
                settings.show(document.body);
            },
            false,
        );

        const acceptAllEventName = eventDispacher.acceptAllEventName();
        document.addEventListener(
            acceptAllEventName,
            () => {
                configuration.Categories.forEach((category) => {
                    status.accept(category.name);
                });
            },
            false,
        );

        const acceptRequiredEventName = eventDispacher.acceptRequiredEventName();
        document.addEventListener(
            acceptRequiredEventName,
            () => {
                    status.accept(requiredCookiesName);
            },
            false,
        );

        status.pageLoad();

        const openSettingsBtns = Array.prototype.slice.call(document.querySelectorAll(openSettingsSelector));
        openSettingsBtns.forEach((element) => {
            element.addEventListener(
                "click",
                () => {
                    eventDispacher.openSettings();
                },
                false,
            );
        });

        const acceptCookieBtns = Array.prototype.slice.call(document.querySelectorAll(acceptCookieSelector));
        acceptCookieBtns.forEach((element) => {
            element.addEventListener(
                "click",
                () => {
                    const cookieName = element.getAttribute("data-accept-cookie");
                    status.accept(cookieName);
                },
                false,
            );
        });
    };

    $(document).ready(() => {
        startCookieConsent(window.cookieConfig);
    });
}());
